module.exports = __webpack_public_path__ + "img/FBox-4.46a8699e.png";